<div
    class="alert-container alert alert-dismissible dark-shadow-sm"
    role="alert"
    [ngClass]="'alert-' + alert.severity"
>
    <div class="d-flex">
        <div
            class="me-2 alert-header"
            *ngIf="alert?.header"
            [innerHtml]="alert.header"
        ></div>
        <div>{{ alert.message }}</div>
    </div>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeAlert(alert)"
    >
    </button>
</div>
